import NextImg from "next/image";
import Link from "next/link";
import { useState } from "react";
import { TextContainer } from "../../../shared/styles/TextContainer";
import endpoints from "../../../../utility/endpoints";
import { useSas } from "../../../../lib/store/useSasStore";

const Image = ({ url, alt }) => {
  const [isError, setError] = useState(false);

  return (
    <>
      <figure className="relative rounded-full overflow-hidden h-28 w-28 mx-auto">
        <img
          onError={() => {
            setError(true);
          }}
          // fill
          layout="fill"
          objectFit="cover"
          sizes="100px"
          src={isError ? "/imagess/no-user-profile.webp" : (url || "/imagess/no-user-profile.webp")}
          className="rounded-full mx-auto h-full w-full object-cover"
          alt={alt}
        />
      </figure>
    </>
  );
};

const TwinCard = ({ twin, showCloneBtn }) => {
 const [isError, setError] = useState(false);
 const {sasToken}=useSas()

  return (
  twin?._source?.employeeTwinName.length>0?
    <>
      <div key={twin?._source?.id} className=" bg-accent rounded-3xl h-[440px]">
        {/* <Link href={`/Employeetwinsdetails?empTwinId=${twin?._source?.employeeTwinID}`} className="block h-full"> */}
        <Link
          href={`/Employeetwinsdetail?empTwinId=${twin?._source?.employeeTwinID}&name=${twin?._source?.employeeTwinName}&leadPlatform=${twin?._source?.leadPlatform}`}>
          <a className="block h-full">
            <div className="text-center flex flex-col justify-between h-full p-8">
              <div className="">
             <Image  url={`${twin?._source?.uploadPhoto}?${sasToken}`} alt={twin?._source?.employeeTwinName} />
                <h3 className="font-medium uppercase mt-4" style={{color:'#551A8B'}}>{twin?._source?.employeeTwinName}</h3>
                <h5 className="text-main capitalize font-medium text-sm">{twin?._source?.leadPlatform}</h5>
                <TextContainer className="mt-2 text-sm leading-6" style={{color:'#551A8B'}}>{twin?._source?.employeeTwinDescription}</TextContainer>
              </div>

              {showCloneBtn ? (
                <div className="">
                  <Link
                    href={`/checkout/individual?empTwinId=${twin?._source?.employeeTwinID}&name=${twin?._source?.employeeTwinName}&image=${twin?._source?.uploadPhoto}`}>
                    <a className="inline-block text-white bg-[#F05C52] px-14 py-2 text-sm font-medium  rounded-full duration-500 hover:bg-opacity-50">Clone</a>
                  </Link>
                </div>
              ) : null}
            </div>
          </a>
        </Link>
      </div>
    </>:null
  );
};

export default TwinCard;
